import { dingTalkRejectDialog } from '@/shared/utils/dingTalkRejectDialog';
import { closeLogoutUserDialog, logoutUserDialog } from '@/shared/utils/logoutUserDialog';
import platform from '@/shared/utils/platform';
import store from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const BaseStore = namespace('base');

@Component
export class UserAuthMixins extends Vue {
  @BaseStore.State isLogoutUser!: boolean;

  // 如果是已注销的用户，则弹窗提示更换账号
  public checkIsLogoutUser(): boolean {
    if (this.isLogoutUser) {
      logoutUserDialog(this);
    } else {
      /** 修复借钱Tab在后台加载“臻有钱”时，token错误，导致已注销弹窗展示错误 */
      if (store.state.base.isHybridAppMode) {
        closeLogoutUserDialog();
      }
      // 需求 SKXDZC-1438  在臻有钱首页，拦截钉钉平台流量，阻止用户进行后续操作
      if (platform.isDingTalk) {
        dingTalkRejectDialog();
      }
    }

    return this.isLogoutUser;
  }
}
